import { IoPeopleOutline } from 'react-icons/io5';

import { routeTo } from '../../../router/utils';

export const userAdmin = ({ t }) => {
  return [
    {
      label: t('Users'),
      icon: <IoPeopleOutline />,
      link: routeTo('users.list'),
    },
  ];
};
